import { useEffect } from "react"
import { useParams, useSearchParams } from "react-router-dom"

export default function BetlabRedirect() {
  return <></>
}
